export default "__VITE_ASSET__Z6AUUVZn__"